import { Link } from 'react-router-dom';
import { buttonClasses } from '@/components/ui/button-styles';
import { CLOSING_IMAGE } from '@/content/images';

/** The orange band that closes the page. */
export function ClosingCtaSection() {
  return (
    <section className="container-page pb-16 lg:pb-20">
      <div className="bg-cta-gradient relative overflow-hidden rounded-[1.5rem]">
        <img
          src={CLOSING_IMAGE.src}
          alt=""
          width={CLOSING_IMAGE.width}
          height={CLOSING_IMAGE.height}
          loading="lazy"
          decoding="async"
          aria-hidden="true"
          // Faded in from the left rather than butted against the orange, so
          // the photograph reads as part of the band and not a pasted panel.
          style={{
            maskImage: 'linear-gradient(90deg, transparent 0%, #000 55%)',
            WebkitMaskImage: 'linear-gradient(90deg, transparent 0%, #000 55%)',
          }}
          className="absolute inset-y-0 right-0 hidden h-full w-1/2 object-cover opacity-45 mix-blend-luminosity sm:block"
        />

        <div className="relative max-w-2xl px-7 py-10 sm:px-10 sm:py-12">
          <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
            Ready to Take the Next Step?
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-white/85 sm:text-base">
            Become a founding member and help shape a safer way for teens and young entrepreneurs to
            grow.
          </p>

          <div className="mt-6 flex flex-wrap gap-3">
            <Link to="/register" className={buttonClasses('sunny', 'sm', 'rounded-full px-5')}>
              I&rsquo;m a Teen
            </Link>
            <Link to="/register" className={buttonClasses('onDark', 'sm', 'rounded-full px-5')}>
              I&rsquo;m Teen+
            </Link>
            <Link to="/register" className={buttonClasses('onDark', 'sm', 'rounded-full px-5')}>
              I&rsquo;m an Entrepreneur
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
